import * as maplibre from 'maplibre-gl';
// MapLibre 6 ships its worker as an ES module importing a shared chunk, which Vite has to bundle on its own
// eslint-disable-next-line import/no-unresolved -- Vite query suffix
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

// Vite only gives the path. Resolving it against this module's URL points it at the asset host, like all other chunks
maplibre.setWorkerUrl(new URL(workerUrl, import.meta.url).href);

export default maplibre;
